<style lang="stylus">
    .pcShare-container
        position relative
        display flex
        background #f9f9fb
        flex 1
        overflow auto
        user-select none
        .pcShare-menu
            position absolute
            left 56px
            top 80px
</style>

<template>
    <div class="pcShare-container">
        <!-- <div @click="changeType">change</div> -->
        <pcShareMenu class="pcShare-menu" v-if="isPC" />
        <component :is="activeType" :ref="type" :type="type" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import share from "./share.vue";
    import shareToMe from "./Wb-shareToMe.vue";
    import pcShareMenu from "./pcShareMenu.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            share,
            shareToMe,
            pcShareMenu,
        },
    })
    export default class PCShare extends Vue {
        activeType: string = "share";

        get type() {
            return this.activeType == "shareToMe" ? "shareToMe" : "";
        }
        //生命周期
        mounted() {
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }

        created() {
            this.$bus.$on("changePCShareView", (str) => {
                if (["share", "shareToMe"].includes(str)) {
                    this.activeType = str;
                }
            });
        }
        beforeDestroy() {
            this.$bus.$off("changePCShareView");
        }
    }
</script>
